import { login, authenticate, authenticateByRfc, validateRFC } from "@/api/user";

export default class User {
  constructor() {

  }

  authenticate = (rfc, nip) => {
    return authenticate(rfc, nip).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  authenticateByRfc = (token_auth, rfc) => {
    return authenticateByRfc(token_auth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  login = (email, password) => {
    return login(email, password).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }
  
  validateRFC = (rfc) => {
    return validateRFC(rfc).then(response => {
      return response;
    }).catch(error =>{
      throw error;
    })
  }
}